import { IconType } from "react-icons";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  Icon?: IconType;
}

export const InputIcon: React.FC<InputProps> = ({ Icon, ...rest }) => (
  <div className="gm-input-icon-container">
    {Icon && <Icon size={16} />}
    <input {...rest} />
  </div>
);
